import { css } from "@linaria/core";

import { contentPaddingProp } from "../../../../app/layout/styles/PageWrapper";
import { TABLET_BREAKPOINT_PX } from "../../../../styles/constants";
import { h1Style, paragraphStyle } from "../../../../styles/defaults";
import { breakpointDownMixin } from "../../../../styles/mixins/breakpoints";
import { colorPropMixin } from "../../../../styles/mixins/colorProp";
import { colorProps } from "../../../../styles/variables";

export const wrapperCls = css`
  background-color: ${colorPropMixin(colorProps.grey_50)};

  &:first-child {
    /**
     * Dangerous; hardcoded pull-up so that there is no white-space on top of
     * the hero on the frontpage
     */
    margin-top: calc(var(${contentPaddingProp}) * -1);
  }
`;

export const boundaryCls = css`
  position: relative;

  padding-top: 8rem;
  padding-bottom: 9rem;

  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }
`;

export const imageCls = css`
  position: absolute;
  right: -6rem;
  bottom: -3rem;

  width: calc(56.75% + 6rem);

  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    display: none;
  }
`;

export const headingCls = css`
  ${h1Style};

  width: calc(100% + 6rem - (56.75% + 6rem) * 0.8);
  font-size: 3rem;

  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    max-width: 69rem;
    width: 100%;
  }
`;

export const bodyCls = css`
  ${paragraphStyle};

  width: 43.25%;

  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    max-width: 69rem;
    width: 100%;
  }
`;
